import React from 'react'
let memoizedfields = new Map()
const WorkAllocationFilterField = (header) => {
    if (memoizedfields.has(header)) {
        return memoizedfields.get(header)
    }

    let fields = [
        {
            name: 'Agency',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Assessment Type',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Payor Type',

            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'MR Number',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Patient Name',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Coder Name',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Chart Status',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'QA Name',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Prod TL',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'QA TL',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Priority',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Review Date Range',
            parent: ['Pending', 'Completed', 'Coding Post Problem', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            name: 'Audit Date Range',
            parent: ['Pending', 'Completed', 'Locked', 'Appeals', 'Hold', 'Ready For Lock', 'Technical Issue'],
        },
        {
            
            name: 'Chart Lock User',
            parent: ['Completed', 'Locked', 'Ready For Lock'],
        },
        {
          
            name: 'Chart Lock Issue',
            parent: ['Completed', 'Locked', 'Ready For Lock'],
        },
        {
           
            name: 'Chart Lock Date Range',
            parent: ['Completed', 'Locked', 'Ready For Lock'],
        },
        {
            
            name: 'Follow Up Date Range',
            parent: ['Coding Post Problem'],
        },
        {
            
            name: 'Follow Up Status',
            parent: ['Coding Post Problem'],
        },
        {
          
            name: 'Coding Level Appeal',
            parent: ['Appeals'],
        }
    ]
    let currentFilterField = fields
        .filter((field) => {
            console.log("fields",field)
            return field.parent.includes(header)
        })
        .map((f) => f.name)
    memoizedfields.set(header, currentFilterField)
    return currentFilterField
}

export default WorkAllocationFilterField
